module.exports = __webpack_public_path__ + "static/media/login-image-desktop.6984c0ea.png";